import { c as _c } from "react/compiler-runtime";
import useCartApplyDiscount from '@/contexts/cartContext/hooks/useCartApplyDiscount';
import useCartDiscount from '@/contexts/cartContext/hooks/useCartDiscount';
import useCartLoading from '@/contexts/cartContext/hooks/useCartLoading';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { Button, Loader } from '@winelidays/wld-tsx-2/elements';
import { Suspense, useEffect, useState } from 'react';
const DiscountForm = () => {
    const $ = _c(33);
    const translate = useTranslate();
    const loadingCart = useCartLoading();
    const { resetDiscountCodeError } = useCartDiscount();
    const applyDiscount = useCartApplyDiscount();
    const [wasClicked, setWasClicked] = useState(false);
    const [code, setCode] = useState("");
    let t0;
    if ($[0] !== translate) {
        t0 = translate("cart_page.discount_form.placeholder");
        $[0] = translate;
        $[1] = t0;
    }
    else {
        t0 = $[1];
    }
    const placeHolder = t0;
    const codeIsValid = code.length > 0;
    const buttonIsDisabled = !codeIsValid;
    let t1;
    if ($[2] !== resetDiscountCodeError) {
        t1 = (e) => {
            setCode(e.target.value);
            resetDiscountCodeError();
        };
        $[2] = resetDiscountCodeError;
        $[3] = t1;
    }
    else {
        t1 = $[3];
    }
    const handleCodeChange = t1;
    let t2;
    if ($[4] !== applyDiscount || $[5] !== code) {
        t2 = () => {
            setWasClicked(true);
            applyDiscount(code);
        };
        $[4] = applyDiscount;
        $[5] = code;
        $[6] = t2;
    }
    else {
        t2 = $[6];
    }
    const handleSubmit = t2;
    let t3;
    if ($[7] !== buttonIsDisabled || $[8] !== handleSubmit) {
        t3 = (e_0) => {
            if (!buttonIsDisabled && e_0.key === "Enter") {
                handleSubmit();
            }
        };
        $[7] = buttonIsDisabled;
        $[8] = handleSubmit;
        $[9] = t3;
    }
    else {
        t3 = $[9];
    }
    const handleKeyUp = t3;
    let t4;
    let t5;
    if ($[10] !== loadingCart) {
        t4 = () => {
            if (!loadingCart) {
                setWasClicked(false);
            }
        };
        t5 = [loadingCart];
        $[10] = loadingCart;
        $[11] = t4;
        $[12] = t5;
    }
    else {
        t4 = $[11];
        t5 = $[12];
    }
    useEffect(t4, t5);
    const [inputFocused, setInputFocused] = useState(false);
    let t6;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = () => {
            setInputFocused(true);
        };
        $[13] = t6;
    }
    else {
        t6 = $[13];
    }
    const onInputFocus = t6;
    let t7;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = () => {
            setInputFocused(false);
        };
        $[14] = t7;
    }
    else {
        t7 = $[14];
    }
    const onInputBlur = t7;
    const [buttonFocused, setButtonFocused] = useState(false);
    let t8;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = () => {
            setButtonFocused(true);
        };
        $[15] = t8;
    }
    else {
        t8 = $[15];
    }
    const onButtonFocus = t8;
    let t9;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = () => {
            setButtonFocused(false);
        };
        $[16] = t9;
    }
    else {
        t9 = $[16];
    }
    const onButtonBlur = t9;
    const inputClassName = `flex-grow rounded-l-full border border-gray-200 pl-4 py-2 ${buttonFocused ? "focus-visible" : ""}`;
    const buttonClassName = `btn-primary !rounded-l-none !rounded-r-full !pl-3 !pr-4 !py-2 ${inputFocused ? "focus-visible" : ""}`;
    let t10;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = <Loader />;
        $[17] = t10;
    }
    else {
        t10 = $[17];
    }
    let t11;
    if ($[18] !== code || $[19] !== handleCodeChange || $[20] !== handleKeyUp || $[21] !== inputClassName || $[22] !== placeHolder) {
        t11 = <input type="text" placeholder={placeHolder} className={inputClassName} value={code} onChange={handleCodeChange} onKeyUp={handleKeyUp} onFocus={onInputFocus} onBlur={onInputBlur}/>;
        $[18] = code;
        $[19] = handleCodeChange;
        $[20] = handleKeyUp;
        $[21] = inputClassName;
        $[22] = placeHolder;
        $[23] = t11;
    }
    else {
        t11 = $[23];
    }
    const t12 = !wasClicked;
    let t13;
    if ($[24] !== buttonClassName || $[25] !== buttonIsDisabled || $[26] !== handleSubmit || $[27] !== loadingCart || $[28] !== t12) {
        t13 = <Button title="Ok" className={buttonClassName} disabled={buttonIsDisabled} busy={loadingCart} hideBusyWheel={t12} onClick={handleSubmit} onFocus={onButtonFocus} onBlur={onButtonBlur}>
      Ok

    </Button>;
        $[24] = buttonClassName;
        $[25] = buttonIsDisabled;
        $[26] = handleSubmit;
        $[27] = loadingCart;
        $[28] = t12;
        $[29] = t13;
    }
    else {
        t13 = $[29];
    }
    let t14;
    if ($[30] !== t11 || $[31] !== t13) {
        t14 = <><Suspense fallback={t10}><div className="flex flex-row">{t11}{t13}
        </div>
      </Suspense></>;
        $[30] = t11;
        $[31] = t13;
        $[32] = t14;
    }
    else {
        t14 = $[32];
    }
    return t14;
};
export default DiscountForm;
